// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />

export class CISAddressTypeAhead {
	private _url: string;
	private _displayingUnits: boolean;

	constructor(url) {
		this._url = url;
		this._displayingUnits = false;
	}

	Setup(typeaheadField: string, melissaField: string, unitField: string) {

		var timeout;

		var typeaheadName: string = typeaheadField;
		var melissaKeyControlName: string = melissaField;
		var unitNumberControlName: string = unitField;

		$("#loadingSpinner").hide();

		var xhr;

		$("#" + typeaheadName).on('paste drop', (e) => {
			$(e.target).prop("title", "Please type an <b>address</b>. You are not able to copy and paste.");
			var tt = $(e.target).tooltip({ placement: "bottom", html: true }).tooltip("show");
			return false;
		});

		$("#" + typeaheadName).on('input', function () {
			if (!$("#" + typeaheadName).val() || $("#" + typeaheadName).val()[0].length === 0) {
				clearTimeout(timeout);
				timeout = null;
				$("#loadingSpinner").hide();
				if (xhr) {
					xhr.abort();
				}
			}
		});

		var map = {};
		var objects = [];
		var bestPictures;


		$("#" + typeaheadName).typeahead({
			highlight: true,
		},
			{
				limit: 20,
				source: (query, syncResults, asyncResults) => {
					if (query.length < 3) {
						return;
					}
					if (timeout) {
						clearTimeout(timeout);
						timeout = null;
					}

					if (xhr) {
						xhr.abort();
					}


					timeout = setTimeout(() => {
						$("#loadingSpinner").show();

						//Handle unique typeahead field names
						if ($(".icf-typeahead-field").length) {
							$(".icf-typeahead-field:not([readonly])").attr("id", typeaheadName);
							$(".icf-typeahead-field:not([readonly])").attr("name", typeaheadName.split('_').join('.'));
						}
												
						//Reset typeahead field to be unique
						if ($(".icf-typeahead-field").length) {
							var uniqueFldId = Date.now();
							$(".icf-typeahead-field").attr("id", uniqueFldId);
							$(".icf-typeahead-field").attr("name", uniqueFldId);
						}

						//var url = '@Url.Action("_TypeaheadAddress", "Eligibility")';

						xhr = $.ajax(
							{
								type: "GET",
								url: this._url + "?address=" + query,
								success: (jsonData) => {
									//console.log(jsonData);
									map = {};
									objects = [];
									$.each(jsonData, (i, object) => {
										map[object.Address] = object;
										objects.push(object.Address);
									});
									asyncResults(objects);
									$("#loadingSpinner").hide();

									clearTimeout(timeout);
									timeout = null;
									xhr = null;
								}
							});
					}, 400);
				},
				templates: {
					notFound: [
						'<div>',
						'No results found',
						'</div>'
					].join('\n')
				}
			}).on("keyup", (e) => {
				//Ignore tab
				if (e.keyCode != 9) {
					$("#" + melissaKeyControlName).val("");
				}
			});;

		$("#" + typeaheadName).on('typeahead:selected', (evt, item) => {
			//Check if selected address has units.
			if (map[item].Units && map[item].Units.length > 0) {
				this._displayingUnits = true;
				$("#" + unitNumberControlName).empty();
				$("#" + unitNumberControlName).append($('<option></option>').attr('value', '').text(''));

				$.each(map[item].Units, (index, item) => {
					$("#" + unitNumberControlName).append($('<option></option>').attr('value', item.MelissaAddressKey).text(item.UnitName));
				});

				$('#unitDiv').removeClass("d-none").show();
				$("#" + melissaKeyControlName).val('');

			} else {
				this._displayingUnits = false;
				$('#unitDiv').hide();
				$("#" + melissaKeyControlName).val(map[item].Key);

				var e: Event = new Event('icf-eligibility-selected');
				document.dispatchEvent(e);
			}
		});

		$("#" + typeaheadName).on("blur", () => {
			var rid = $("#" + melissaKeyControlName).val();
			if ((rid == "" || rid == null) && (this._displayingUnits == false)) {
				CISAddressTypeAhead.SetCISTypeaheadError(typeaheadName.split('_').join('.'), "Please select an address from the list.");
				$("#" + typeaheadName).val("");

				var e: Event = new Event('icf-eligibility-deselected');
				document.dispatchEvent(e);

			} else {
				CISAddressTypeAhead.SetCISTypeaheadError(typeaheadName.split('_').join('.'), "");
			}

		});


		$('#' + unitNumberControlName).on("change", () => {
			$("#" + melissaKeyControlName).val($("#" + unitNumberControlName).val());

			var e: Event = new Event('icf-eligibility-selected');
			document.dispatchEvent(e);
		});

		$("#" + typeaheadName).prop('autocomplete', 'notallowed');
	}

    public static InitTypeaheadFieldName() {
        //Reset typeahead field to be unique
        if ($(".icf-typeahead-field").length) {
            var uniqueFldId = Date.now();
            $(".icf-typeahead-field").attr("id", uniqueFldId);
            $(".icf-typeahead-field").attr("name", uniqueFldId);
        }
    }

    public static RevertTypeaheadFieldName(typeaheadName: string) {
        //Handle unique typeahead field names
        if ($(".icf-typeahead-field").length) {
            $(".icf-typeahead-field:not([readonly])").attr("id", typeaheadName);
            $(".icf-typeahead-field:not([readonly])").attr("name", typeaheadName.split('_').join('.'));
        }
    }

	public static SetCISTypeaheadError(id, message) {
		var span = $("span[data-valmsg-for=\"" + id + "\"]");
		if (span && span.length > 0) {
			$(span).html(message);
			if (message && message != "") {
				$(span).removeClass("field-validation-valid");
				$(span).addClass("field-validation-no-valid");
			} else {
				$(span).removeClass("field-validation-no-valid");
				$(span).addClass("field-validation-valid");
			}
		}
	}
}
